function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _ = Object.defineProperty;
var $ = function(a, h, e) {
    return h in a ? _(a, h, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : a[h] = e;
};
var m = function(a, h, e) {
    return $(a, (typeof h === "undefined" ? "undefined" : _type_of(h)) != "symbol" ? h + "" : h, e);
};
import u, { PureComponent as K, createRef as P } from "react";
var E = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    unit: "px"
}, b = function(a, h, e) {
    return Math.min(Math.max(a, h), e);
}, H = function() {
    for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
        a[_key] = arguments[_key];
    }
    return a.filter(function(h) {
        return h && typeof h == "string";
    }).join(" ");
}, X = function(a, h) {
    return a === h || a.width === h.width && a.height === h.height && a.x === h.x && a.y === h.y && a.unit === h.unit;
};
function B(a, h, e, n) {
    var t = D(a, e, n);
    return a.width && (t.height = t.width / h), a.height && (t.width = t.height * h), t.y + t.height > n && (t.height = n - t.y, t.width = t.height * h), t.x + t.width > e && (t.width = e - t.x, t.height = t.width / h), a.unit === "%" ? v(t, e, n) : t;
}
function L(a, h, e) {
    var n = D(a, h, e);
    return n.x = (h - n.width) / 2, n.y = (e - n.height) / 2, a.unit === "%" ? v(n, h, e) : n;
}
function v(a, h, e) {
    return a.unit === "%" ? _object_spread_props(_object_spread({}, E, a), {
        unit: "%"
    }) : {
        unit: "%",
        x: a.x ? a.x / h * 100 : 0,
        y: a.y ? a.y / e * 100 : 0,
        width: a.width ? a.width / h * 100 : 0,
        height: a.height ? a.height / e * 100 : 0
    };
}
function D(a, h, e) {
    return a.unit ? a.unit === "px" ? _object_spread_props(_object_spread({}, E, a), {
        unit: "px"
    }) : {
        unit: "px",
        x: a.x ? a.x * h / 100 : 0,
        y: a.y ? a.y * e / 100 : 0,
        width: a.width ? a.width * h / 100 : 0,
        height: a.height ? a.height * e / 100 : 0
    } : _object_spread_props(_object_spread({}, E, a), {
        unit: "px"
    });
}
function k(a, h, e, n, t) {
    var d = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, r = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0, o = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : n, w = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : t;
    var i = _object_spread({}, a);
    var s = Math.min(d, n), c = Math.min(r, t), g = Math.min(o, n), p = Math.min(w, t);
    h && (h > 1 ? (s = r ? r * h : s, c = s / h, g = o * h) : (c = d ? d / h : c, s = c * h, p = w / h)), i.y < 0 && (i.height = Math.max(i.height + i.y, c), i.y = 0), i.x < 0 && (i.width = Math.max(i.width + i.x, s), i.x = 0);
    var l = n - (i.x + i.width);
    l < 0 && (i.x = Math.min(i.x, n - s), i.width += l);
    var C = t - (i.y + i.height);
    if (C < 0 && (i.y = Math.min(i.y, t - c), i.height += C), i.width < s && ((e === "sw" || e == "nw") && (i.x -= s - i.width), i.width = s), i.height < c && ((e === "nw" || e == "ne") && (i.y -= c - i.height), i.height = c), i.width > g && ((e === "sw" || e == "nw") && (i.x -= g - i.width), i.width = g), i.height > p && ((e === "nw" || e == "ne") && (i.y -= p - i.height), i.height = p), h) {
        var y = i.width / i.height;
        if (y < h) {
            var f = Math.max(i.width / h, c);
            (e === "nw" || e == "ne") && (i.y -= f - i.height), i.height = f;
        } else if (y > h) {
            var f1 = Math.max(i.height * h, s);
            (e === "sw" || e == "nw") && (i.x -= f1 - i.width), i.width = f1;
        }
    }
    return i;
}
function I(a, h, e, n) {
    var t = _object_spread({}, a);
    return h === "ArrowLeft" ? n === "nw" ? (t.x -= e, t.y -= e, t.width += e, t.height += e) : n === "w" ? (t.x -= e, t.width += e) : n === "sw" ? (t.x -= e, t.width += e, t.height += e) : n === "ne" ? (t.y += e, t.width -= e, t.height -= e) : n === "e" ? t.width -= e : n === "se" && (t.width -= e, t.height -= e) : h === "ArrowRight" && (n === "nw" ? (t.x += e, t.y += e, t.width -= e, t.height -= e) : n === "w" ? (t.x += e, t.width -= e) : n === "sw" ? (t.x += e, t.width -= e, t.height -= e) : n === "ne" ? (t.y -= e, t.width += e, t.height += e) : n === "e" ? t.width += e : n === "se" && (t.width += e, t.height += e)), h === "ArrowUp" ? n === "nw" ? (t.x -= e, t.y -= e, t.width += e, t.height += e) : n === "n" ? (t.y -= e, t.height += e) : n === "ne" ? (t.y -= e, t.width += e, t.height += e) : n === "sw" ? (t.x += e, t.width -= e, t.height -= e) : n === "s" ? t.height -= e : n === "se" && (t.width -= e, t.height -= e) : h === "ArrowDown" && (n === "nw" ? (t.x += e, t.y += e, t.width -= e, t.height -= e) : n === "n" ? (t.y += e, t.height -= e) : n === "ne" ? (t.y += e, t.width -= e, t.height -= e) : n === "sw" ? (t.x -= e, t.width += e, t.height += e) : n === "s" ? t.height += e : n === "se" && (t.width += e, t.height += e)), t;
}
var M = {
    capture: !0,
    passive: !1
};
var N = 0;
var x = /*#__PURE__*/ function(K) {
    "use strict";
    _inherits(x, K);
    function x() {
        _class_call_check(this, x);
        var _this;
        _this = _call_super(this, x, arguments);
        m(_this, "docMoveBound", !1);
        m(_this, "mouseDownOnCrop", !1);
        m(_this, "dragStarted", !1);
        m(_this, "evData", {
            startClientX: 0,
            startClientY: 0,
            startCropX: 0,
            startCropY: 0,
            clientX: 0,
            clientY: 0,
            isResize: !0
        });
        m(_this, "componentRef", /*#__PURE__*/ P());
        m(_this, "mediaRef", /*#__PURE__*/ P());
        m(_this, "resizeObserver");
        m(_this, "initChangeCalled", !1);
        m(_this, "instanceId", "rc-".concat(N++));
        m(_this, "state", {
            cropIsActive: !1,
            newCropIsBeingDrawn: !1
        });
        m(_this, "onCropPointerDown", function(e) {
            var _this_props = _this.props, n = _this_props.crop, t = _this_props.disabled, d = _this.getBox();
            if (!n) return;
            var r = D(n, d.width, d.height);
            if (t) return;
            e.cancelable && e.preventDefault(), _this.bindDocMove(), _this.componentRef.current.focus({
                preventScroll: !0
            });
            var o = e.target.dataset.ord, w = !!o;
            var i = e.clientX, s = e.clientY, c = r.x, g = r.y;
            if (o) {
                var p = e.clientX - d.x, l = e.clientY - d.y;
                var C = 0, y = 0;
                o === "ne" || o == "e" ? (C = p - (r.x + r.width), y = l - r.y, c = r.x, g = r.y + r.height) : o === "se" || o === "s" ? (C = p - (r.x + r.width), y = l - (r.y + r.height), c = r.x, g = r.y) : o === "sw" || o == "w" ? (C = p - r.x, y = l - (r.y + r.height), c = r.x + r.width, g = r.y) : (o === "nw" || o == "n") && (C = p - r.x, y = l - r.y, c = r.x + r.width, g = r.y + r.height), i = c + d.x + C, s = g + d.y + y;
            }
            _this.evData = {
                startClientX: i,
                startClientY: s,
                startCropX: c,
                startCropY: g,
                clientX: e.clientX,
                clientY: e.clientY,
                isResize: w,
                ord: o
            }, _this.mouseDownOnCrop = !0, _this.setState({
                cropIsActive: !0
            });
        });
        m(_this, "onComponentPointerDown", function(e) {
            var _this_props = _this.props, n = _this_props.crop, t = _this_props.disabled, d = _this_props.locked, r = _this_props.keepSelection, o = _this_props.onChange, w = _this.getBox();
            if (t || d || r && n) return;
            e.cancelable && e.preventDefault(), _this.bindDocMove(), _this.componentRef.current.focus({
                preventScroll: !0
            });
            var i = e.clientX - w.x, s = e.clientY - w.y, c = {
                unit: "px",
                x: i,
                y: s,
                width: 0,
                height: 0
            };
            _this.evData = {
                startClientX: e.clientX,
                startClientY: e.clientY,
                startCropX: i,
                startCropY: s,
                clientX: e.clientX,
                clientY: e.clientY,
                isResize: !0
            }, _this.mouseDownOnCrop = !0, o(D(c, w.width, w.height), v(c, w.width, w.height)), _this.setState({
                cropIsActive: !0,
                newCropIsBeingDrawn: !0
            });
        });
        m(_this, "onDocPointerMove", function(e) {
            var _this_props = _this.props, n = _this_props.crop, t = _this_props.disabled, d = _this_props.onChange, r = _this_props.onDragStart, o = _this.getBox();
            if (t || !n || !_this.mouseDownOnCrop) return;
            e.cancelable && e.preventDefault(), _this.dragStarted || (_this.dragStarted = !0, r && r(e));
            var w = _this.evData;
            w.clientX = e.clientX, w.clientY = e.clientY;
            var i;
            w.isResize ? i = _this.resizeCrop() : i = _this.dragCrop(), X(n, i) || d(D(i, o.width, o.height), v(i, o.width, o.height));
        });
        m(_this, "onComponentKeyDown", function(e) {
            var _this_props = _this.props, n = _this_props.crop, t = _this_props.disabled, d = _this_props.onChange, r = _this_props.onComplete;
            if (t) return;
            var o = e.key;
            var w = !1;
            if (!n) return;
            var i = _this.getBox(), s = _this.makePixelCrop(i), g = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? x.nudgeStepLarge : e.shiftKey ? x.nudgeStepMedium : x.nudgeStep;
            if (o === "ArrowLeft" ? (s.x -= g, w = !0) : o === "ArrowRight" ? (s.x += g, w = !0) : o === "ArrowUp" ? (s.y -= g, w = !0) : o === "ArrowDown" && (s.y += g, w = !0), w) {
                e.cancelable && e.preventDefault(), s.x = b(s.x, 0, i.width - s.width), s.y = b(s.y, 0, i.height - s.height);
                var p = D(s, i.width, i.height), l = v(s, i.width, i.height);
                d(p, l), r && r(p, l);
            }
        });
        m(_this, "onHandlerKeyDown", function(e, n) {
            var _this_props = _this.props, tmp = _this_props.aspect, t = tmp === void 0 ? 0 : tmp, d = _this_props.crop, r = _this_props.disabled, tmp1 = _this_props.minWidth, o = tmp1 === void 0 ? 0 : tmp1, tmp2 = _this_props.minHeight, w = tmp2 === void 0 ? 0 : tmp2, i = _this_props.maxWidth, s = _this_props.maxHeight, c = _this_props.onChange, g = _this_props.onComplete, p = _this.getBox();
            if (r || !d) return;
            if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "ArrowLeft" || e.key === "ArrowRight") e.stopPropagation(), e.preventDefault();
            else return;
            var C = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? x.nudgeStepLarge : e.shiftKey ? x.nudgeStepMedium : x.nudgeStep, y = D(d, p.width, p.height), f = I(y, e.key, C, n), R = k(f, t, n, p.width, p.height, o, w, i, s);
            if (!X(d, R)) {
                var Y = v(R, p.width, p.height);
                c(R, Y), g && g(R, Y);
            }
        });
        m(_this, "onDocPointerDone", function(e) {
            var _this_props = _this.props, n = _this_props.crop, t = _this_props.disabled, d = _this_props.onComplete, r = _this_props.onDragEnd, o = _this.getBox();
            _this.unbindDocMove(), !(t || !n) && _this.mouseDownOnCrop && (_this.mouseDownOnCrop = !1, _this.dragStarted = !1, r && r(e), d && d(D(n, o.width, o.height), v(n, o.width, o.height)), _this.setState({
                cropIsActive: !1,
                newCropIsBeingDrawn: !1
            }));
        });
        m(_this, "onDragFocus", function() {
            var e;
            (e = _this.componentRef.current) == null || e.scrollTo(0, 0);
        });
        return _this;
    }
    _create_class(x, [
        {
            key: "document",
            get: function get() {
                return document;
            }
        },
        {
            // We unfortunately get the bounding box every time as x+y changes
            // due to scrolling.
            key: "getBox",
            value: function getBox() {
                var e = this.mediaRef.current;
                if (!e) return {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
                var _e_getBoundingClientRect = e.getBoundingClientRect(), n = _e_getBoundingClientRect.x, t = _e_getBoundingClientRect.y, d = _e_getBoundingClientRect.width, r = _e_getBoundingClientRect.height;
                return {
                    x: n,
                    y: t,
                    width: d,
                    height: r
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(e) {
                var _this_props = this.props, n = _this_props.crop, t = _this_props.onComplete;
                if (t && !e.crop && n) {
                    var _this_getBox = this.getBox(), d = _this_getBox.width, r = _this_getBox.height;
                    d && r && t(D(n, d, r), v(n, d, r));
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.resizeObserver && this.resizeObserver.disconnect(), this.unbindDocMove();
            }
        },
        {
            key: "bindDocMove",
            value: function bindDocMove() {
                this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, M), this.document.addEventListener("pointerup", this.onDocPointerDone, M), this.document.addEventListener("pointercancel", this.onDocPointerDone, M), this.docMoveBound = !0);
            }
        },
        {
            key: "unbindDocMove",
            value: function unbindDocMove() {
                this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, M), this.document.removeEventListener("pointerup", this.onDocPointerDone, M), this.document.removeEventListener("pointercancel", this.onDocPointerDone, M), this.docMoveBound = !1);
            }
        },
        {
            key: "getCropStyle",
            value: function getCropStyle() {
                var _this_props = this.props, e = _this_props.crop;
                if (e) return {
                    top: "".concat(e.y).concat(e.unit),
                    left: "".concat(e.x).concat(e.unit),
                    width: "".concat(e.width).concat(e.unit),
                    height: "".concat(e.height).concat(e.unit)
                };
            }
        },
        {
            key: "dragCrop",
            value: function dragCrop() {
                var _this = this, e = _this.evData, n = this.getBox(), t = this.makePixelCrop(n), d = e.clientX - e.startClientX, r = e.clientY - e.startClientY;
                return t.x = b(e.startCropX + d, 0, n.width - t.width), t.y = b(e.startCropY + r, 0, n.height - t.height), t;
            }
        },
        {
            key: "getPointRegion",
            value: function getPointRegion(e, n, t, d) {
                var _this = this, r = _this.evData, o = r.clientX - e.x, w = r.clientY - e.y;
                var i;
                d && n ? i = n === "nw" || n === "n" || n === "ne" : i = w < r.startCropY;
                var s;
                return t && n ? s = n === "nw" || n === "w" || n === "sw" : s = o < r.startCropX, s ? i ? "nw" : "sw" : i ? "ne" : "se";
            }
        },
        {
            key: "resolveMinDimensions",
            value: function resolveMinDimensions(e, n) {
                var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, d = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                var r = Math.min(t, e.width), o = Math.min(d, e.height);
                return !n || !r && !o ? [
                    r,
                    o
                ] : n > 1 ? r ? [
                    r,
                    r / n
                ] : [
                    o * n,
                    o
                ] : o ? [
                    o * n,
                    o
                ] : [
                    r,
                    r / n
                ];
            }
        },
        {
            key: "resizeCrop",
            value: function resizeCrop() {
                var _this = this, e = _this.evData, _this_props = this.props, tmp = _this_props.aspect, n = tmp === void 0 ? 0 : tmp, t = _this_props.maxWidth, d = _this_props.maxHeight, r = this.getBox(), _this_resolveMinDimensions = _sliced_to_array(this.resolveMinDimensions(r, n, this.props.minWidth, this.props.minHeight), 2), o = _this_resolveMinDimensions[0], w = _this_resolveMinDimensions[1];
                var i = this.makePixelCrop(r);
                var s = this.getPointRegion(r, e.ord, o, w), c = e.ord || s;
                var g = e.clientX - e.startClientX, p = e.clientY - e.startClientY;
                (o && c === "nw" || c === "w" || c === "sw") && (g = Math.min(g, -o)), (w && c === "nw" || c === "n" || c === "ne") && (p = Math.min(p, -w));
                var l = {
                    unit: "px",
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
                s === "ne" ? (l.x = e.startCropX, l.width = g, n ? (l.height = l.width / n, l.y = e.startCropY - l.height) : (l.height = Math.abs(p), l.y = e.startCropY - l.height)) : s === "se" ? (l.x = e.startCropX, l.y = e.startCropY, l.width = g, n ? l.height = l.width / n : l.height = p) : s === "sw" ? (l.x = e.startCropX + g, l.y = e.startCropY, l.width = Math.abs(g), n ? l.height = l.width / n : l.height = p) : s === "nw" && (l.x = e.startCropX + g, l.width = Math.abs(g), n ? (l.height = l.width / n, l.y = e.startCropY - l.height) : (l.height = Math.abs(p), l.y = e.startCropY + p));
                var C = k(l, n, s, r.width, r.height, o, w, t, d);
                return n || x.xyOrds.indexOf(c) > -1 ? i = C : x.xOrds.indexOf(c) > -1 ? (i.x = C.x, i.width = C.width) : x.yOrds.indexOf(c) > -1 && (i.y = C.y, i.height = C.height), i.x = b(i.x, 0, r.width - i.width), i.y = b(i.y, 0, r.height - i.height), i;
            }
        },
        {
            key: "renderCropSelection",
            value: function renderCropSelection() {
                var _this = this;
                var _this_props = this.props, tmp = _this_props.ariaLabels, e = tmp === void 0 ? x.defaultProps.ariaLabels : tmp, n = _this_props.disabled, t = _this_props.locked, d = _this_props.renderSelectionAddon, r = _this_props.ruleOfThirds, o = _this_props.crop, w = this.getCropStyle();
                if (o) return /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    style: w,
                    className: "ReactCrop__crop-selection",
                    onPointerDown: this.onCropPointerDown,
                    "aria-label": e.cropArea,
                    tabIndex: 0,
                    onKeyDown: this.onComponentKeyDown,
                    role: "group"
                }, !n && !t && /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-elements",
                    onFocus: this.onDragFocus
                }, /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-bar ord-n",
                    "data-ord": "n"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-bar ord-e",
                    "data-ord": "e"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-bar ord-s",
                    "data-ord": "s"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-bar ord-w",
                    "data-ord": "w"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-handle ord-nw",
                    "data-ord": "nw",
                    tabIndex: 0,
                    "aria-label": e.nwDragHandle,
                    onKeyDown: function(i) {
                        return _this.onHandlerKeyDown(i, "nw");
                    },
                    role: "button"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-handle ord-n",
                    "data-ord": "n",
                    tabIndex: 0,
                    "aria-label": e.nDragHandle,
                    onKeyDown: function(i) {
                        return _this.onHandlerKeyDown(i, "n");
                    },
                    role: "button"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-handle ord-ne",
                    "data-ord": "ne",
                    tabIndex: 0,
                    "aria-label": e.neDragHandle,
                    onKeyDown: function(i) {
                        return _this.onHandlerKeyDown(i, "ne");
                    },
                    role: "button"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-handle ord-e",
                    "data-ord": "e",
                    tabIndex: 0,
                    "aria-label": e.eDragHandle,
                    onKeyDown: function(i) {
                        return _this.onHandlerKeyDown(i, "e");
                    },
                    role: "button"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-handle ord-se",
                    "data-ord": "se",
                    tabIndex: 0,
                    "aria-label": e.seDragHandle,
                    onKeyDown: function(i) {
                        return _this.onHandlerKeyDown(i, "se");
                    },
                    role: "button"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-handle ord-s",
                    "data-ord": "s",
                    tabIndex: 0,
                    "aria-label": e.sDragHandle,
                    onKeyDown: function(i) {
                        return _this.onHandlerKeyDown(i, "s");
                    },
                    role: "button"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-handle ord-sw",
                    "data-ord": "sw",
                    tabIndex: 0,
                    "aria-label": e.swDragHandle,
                    onKeyDown: function(i) {
                        return _this.onHandlerKeyDown(i, "sw");
                    },
                    role: "button"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__drag-handle ord-w",
                    "data-ord": "w",
                    tabIndex: 0,
                    "aria-label": e.wDragHandle,
                    onKeyDown: function(i) {
                        return _this.onHandlerKeyDown(i, "w");
                    },
                    role: "button"
                })), d && /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__selection-addon",
                    onPointerDown: function(i) {
                        return i.stopPropagation();
                    }
                }, d(this.state)), r && /* @__PURE__ */ /*#__PURE__*/ u.createElement(u.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__rule-of-thirds-hz"
                }), /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    className: "ReactCrop__rule-of-thirds-vt"
                })));
            }
        },
        {
            key: "makePixelCrop",
            value: function makePixelCrop(e) {
                var n = _object_spread({}, E, this.props.crop || {});
                return D(n, e.width, e.height);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, e = _this_props.aspect, n = _this_props.children, t = _this_props.circularCrop, d = _this_props.className, r = _this_props.crop, o = _this_props.disabled, w = _this_props.locked, i = _this_props.style, s = _this_props.ruleOfThirds, _this_state = this.state, c = _this_state.cropIsActive, g = _this_state.newCropIsBeingDrawn, p = r ? this.renderCropSelection() : null, l = H("ReactCrop", d, c && "ReactCrop--active", o && "ReactCrop--disabled", w && "ReactCrop--locked", g && "ReactCrop--new-crop", r && e && "ReactCrop--fixed-aspect", r && t && "ReactCrop--circular-crop", r && s && "ReactCrop--rule-of-thirds", !this.dragStarted && r && !r.width && !r.height && "ReactCrop--invisible-crop", t && "ReactCrop--no-animate");
                return /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    ref: this.componentRef,
                    className: l,
                    style: i
                }, /* @__PURE__ */ /*#__PURE__*/ u.createElement("div", {
                    ref: this.mediaRef,
                    className: "ReactCrop__child-wrapper",
                    onPointerDown: this.onComponentPointerDown
                }, n), r ? /* @__PURE__ */ /*#__PURE__*/ u.createElement("svg", {
                    className: "ReactCrop__crop-mask",
                    width: "100%",
                    height: "100%"
                }, /* @__PURE__ */ /*#__PURE__*/ u.createElement("defs", null, /* @__PURE__ */ /*#__PURE__*/ u.createElement("mask", {
                    id: "hole-".concat(this.instanceId)
                }, /* @__PURE__ */ /*#__PURE__*/ u.createElement("rect", {
                    width: "100%",
                    height: "100%",
                    fill: "white"
                }), t ? /* @__PURE__ */ /*#__PURE__*/ u.createElement("ellipse", {
                    cx: "".concat(r.x + r.width / 2).concat(r.unit),
                    cy: "".concat(r.y + r.height / 2).concat(r.unit),
                    rx: "".concat(r.width / 2).concat(r.unit),
                    ry: "".concat(r.height / 2).concat(r.unit),
                    fill: "black"
                }) : /* @__PURE__ */ /*#__PURE__*/ u.createElement("rect", {
                    x: "".concat(r.x).concat(r.unit),
                    y: "".concat(r.y).concat(r.unit),
                    width: "".concat(r.width).concat(r.unit),
                    height: "".concat(r.height).concat(r.unit),
                    fill: "black"
                }))), /* @__PURE__ */ /*#__PURE__*/ u.createElement("rect", {
                    fill: "black",
                    fillOpacity: 0.5,
                    width: "100%",
                    height: "100%",
                    mask: "url(#hole-".concat(this.instanceId, ")")
                })) : void 0, p);
            }
        }
    ]);
    return x;
}(K);
m(x, "xOrds", [
    "e",
    "w"
]), m(x, "yOrds", [
    "n",
    "s"
]), m(x, "xyOrds", [
    "nw",
    "ne",
    "se",
    "sw"
]), m(x, "nudgeStep", 1), m(x, "nudgeStepMedium", 10), m(x, "nudgeStepLarge", 100), m(x, "defaultProps", {
    ariaLabels: {
        cropArea: "Use the arrow keys to move the crop selection area",
        nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
        nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
        neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
        eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
        seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
        sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
        swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
        wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
    }
});
var S = x;
export { S as Component, S as ReactCrop, X as areCropsEqual, L as centerCrop, b as clamp, H as cls, k as containCrop, v as convertToPercentCrop, D as convertToPixelCrop, S as default, E as defaultCrop, B as makeAspectCrop, I as nudgeCrop };
